import { useRef, useState } from "react";

import classes from "./Checkout.module.css";

const isEmpty = (value) => value.trim() === "";
const is6of7Chars = (value) =>
  value.trim().length === 6 || value.trim().length === 7;
const isEmail = (value) => value.includes("@") && value.includes(".");

const Checkout = (props) => {
  // One combined state slice
  // Set all to true to avoid error messages at the beginning.
  const [formInputsValidity, setFormInputsValidity] = useState({
    firstname: true,
    lastname: true,
    street: true,
    housenumber: true,
    postalCode: true,
    city: true,
    email: true,
  });

  const firstnameInputRef = useRef();
  const lastnameInputRef = useRef();
  const streetInputRef = useRef();
  const housenumberInputRef = useRef();
  const postalCodeInputRef = useRef();
  const cityInputRef = useRef();
  const emailInputRef = useRef();

  // We will get event object automatically because we bind this function to the onSubmit event on the form.
  const confirmHandler = (event) => {
    event.preventDefault();

    const enteredFirstName = firstnameInputRef.current.value; // Altijd current
    const enteredLastName = lastnameInputRef.current.value; // Altijd current
    const enteredStreet = streetInputRef.current.value;
    const enteredHouseNumber = housenumberInputRef.current.value;
    const enteredPostalCode = postalCodeInputRef.current.value;
    const enteredCity = cityInputRef.current.value;
    const enteredEmail = emailInputRef.current.value;

    const enteredFirstNameIsValid = !isEmpty(enteredFirstName);
    const enteredLastNameIsValid = !isEmpty(enteredLastName);
    const enteredStreetIsValid = !isEmpty(enteredStreet);
    const enteredHouseNumberIsValid = !isEmpty(enteredHouseNumber);
    const enteredCityIsValid = !isEmpty(enteredCity);
    const enteredPostalCodeIsValid = is6of7Chars(enteredPostalCode);
    const enteredEmailIsValid = isEmail(enteredEmail);

    setFormInputsValidity({
      firstname: enteredFirstNameIsValid,
      lastname: enteredLastNameIsValid,
      street: enteredStreetIsValid,
      housenumber: enteredHouseNumberIsValid,
      postalCode: enteredPostalCodeIsValid,
      city: enteredCityIsValid,
      email: enteredEmailIsValid,
    });

    const formIsValid =
      enteredFirstNameIsValid &&
      enteredLastNameIsValid &&
      enteredStreetIsValid &&
      enteredHouseNumberIsValid &&
      enteredPostalCodeIsValid &&
      enteredCityIsValid &&
      enteredEmailIsValid;

    if (!formIsValid) {
      return;
    }

    props.onConfirm({
      voornaam: enteredFirstName,
      achternaam: enteredLastName,
      straat: enteredStreet,
      huisnummer: enteredHouseNumber,
      postcode: enteredPostalCode,
      woonplaats: enteredCity,
      email: enteredEmail,
    });
  };

  const firstnameControlClasses = `${classes.control} ${
    formInputsValidity.firstname ? "" : classes.invalid
  }`;
  const lastnameControlClasses = `${classes.control} ${
    formInputsValidity.lastname ? "" : classes.invalid
  }`;
  const streetControlClasses = `${classes.control} ${
    formInputsValidity.street ? "" : classes.invalid
  }`;
  const housenumberControlClasses = `${classes.control} ${
    formInputsValidity.housenumber ? "" : classes.invalid
  }`;
  const postalCodeControlClasses = `${classes.control} ${
    formInputsValidity.postalCode ? "" : classes.invalid
  }`;
  const cityControlClasses = `${classes.control} ${
    formInputsValidity.city ? "" : classes.invalid
  }`;
  const emailControlClasses = `${classes.control} ${
    formInputsValidity.email ? "" : classes.invalid
  }`;

  // Waarde voor htmlFor dient gelijk te zijn aan de waarde van id
  return (
    <form className={classes.form} onSubmit={confirmHandler}>
      <div className={firstnameControlClasses}>
        <label htmlFor="firstname">Voornaam</label>
        <input type="text" id="firstname" ref={firstnameInputRef} />
        {/* formInputsValidity is een object met 4 properties */}
        {!formInputsValidity.firstname && <p>Voer een geldige voornaam in!</p>}
      </div>
      <div className={lastnameControlClasses}>
        <label htmlFor="lastname">Achternaam</label>
        <input type="text" id="lastname" ref={lastnameInputRef} />
        {/* formInputsValidity is een object met 4 properties */}
        {!formInputsValidity.lastname && <p>Voer een geldige achternaam in!</p>}
      </div>
      <div className={streetControlClasses}>
        <label htmlFor="street">Straat</label>
        <input type="text" id="street" ref={streetInputRef} />
        {!formInputsValidity.street && <p>Voer een geldige straat in!</p>}
      </div>
      <div className={housenumberControlClasses}>
        <label htmlFor="housenumber">Huisnummer</label>
        <input type="text" id="housenumber" ref={housenumberInputRef} />
        {!formInputsValidity.housenumber && (
          <p>Voer een geldig huisnummer in!</p>
        )}
      </div>
      <div className={postalCodeControlClasses}>
        <label htmlFor="postal">Postcode</label>
        <input type="text" id="postal" ref={postalCodeInputRef} />
        {!formInputsValidity.postalCode && (
          <p>Voer een geldige postcode in (6 of 7 characters lang)!</p>
        )}
      </div>
      <div className={cityControlClasses}>
        <label htmlFor="city">Woonplaats</label>
        <input type="text" id="city" ref={cityInputRef} />
        {!formInputsValidity.city && <p>Voer een geldige woonplaats in!</p>}
      </div>
      <div className={emailControlClasses}>
        <label htmlFor="email">Email</label>
        <input type="text" id="email" ref={emailInputRef} />
        {!formInputsValidity.email && <p>Voer een geldige email in!</p>}
      </div>
      <div className={classes.actions}>
        <button type="button" onClick={props.onCancel}>
          {/* type='button' so that it does not submit the form */}
          Annuleren
        </button>
        <button className={classes.submit}>Bestellen</button>{" "}
        {/* Only this button will trigger this form submission and will therefore trigger the confirmHandler function */}
      </div>
    </form>
  );
};

export default Checkout;
